import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { addedFilesStudents, countOpenMaterials, countsDzExamsStudents } from './StatisticsStudentUtils';
import completedHomeworkIcon from '../../../assets/img/completed-homework-icon.svg';
import statisticsBookIcon from '../../../assets/img/statistics-book-icon.svg';
import statisticsFileIcon from '../../../assets/img/statistics-file-icon.svg';
import {
  selectMaterials,
  selectNotebooks,
  selectStudents,
  selectTeachers,
} from '../../../redux/slices/statistics/additionalStatisticsSlice';
import { selectCurrentUser, selectSearchQuery } from '../../../redux/slices/statistics/statisticsSlice';
import { StatisticsCompletedHomework } from '../StatisticsCompletedHomework/StatisticsCompletedHomework';
import { StatisticsSquareSmall } from '../StatisticsSquareSmall/StatisticsSquareSmall';
import './style.scss';

export const StatisticsStudent = () => {
  const { t } = useTranslation();
  const currentSearchQuery = useSelector(selectSearchQuery);
  const currentUser = useSelector(selectCurrentUser);
  const students = useSelector(selectStudents);
  const teachers = useSelector(selectTeachers);
  const notebooks = useSelector(selectNotebooks);
  const materials = useSelector(selectMaterials);

  return (
    <div className="statistics-teacher statistics-content-block">
      {currentSearchQuery && currentUser && students && teachers && notebooks && materials && (
        <>
          <div className="statistics-content-block-bottom">
            <h2>
              {t('Student statistics')} {currentSearchQuery}
            </h2>

            <div className="statistics-content-block-row">
              <StatisticsSquareSmall
                icon={statisticsBookIcon}
                count={countOpenMaterials(students, currentUser.email)}
                text={'primary materials openly'}
              />

              <StatisticsCompletedHomework
                count={countsDzExamsStudents(students, currentUser.email).total}
                countCl={countsDzExamsStudents(students, currentUser.email).cl}
                countDz={countsDzExamsStudents(students, currentUser.email).dz}
                clPercentage={countsDzExamsStudents(students, currentUser.email).clPercentage}
                dzPercentage={countsDzExamsStudents(students, currentUser.email).dzPercentage}
                text={'completed'}
                icon={completedHomeworkIcon}
              />

              <StatisticsSquareSmall
                icon={statisticsFileIcon}
                count={addedFilesStudents(students, currentUser.email)}
                text={'file added to the site'}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
